import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
        backgroundColor: "#E4F5EC",
        borderRadius: "4px",
        padding: "12px",
        position: "relative",
    },

    mobile_container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        backgroundColor: "#E4F5EC",
        borderRadius: "4px",
        padding: "20px",
    },

    leftSide: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
    },
    rightSide: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        height: "100%",
    },

    box: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        color: "#353535",
        fontSize: "16px",
        letterSpacing: 0,
        padding: "12px",
    },
    mobile_box: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        color: "#353535",
        fontSize: "16px",
        letterSpacing: 0,
        padding: "12px 0px",
    },

    box_title: {
        fontSize: "20px",
        color: "#00833E",
        fontWeight: 500,
        marginBottom: "6px",
    },

    bold: {
        fontWeight: 500,
    },

    marginBox: {
        marginBottom: "6px",
    },

    smallGreenDesc: {
        width: "100%",
        padding: 24,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    smallGreenDescArrow: {
        width: 24,
        height: 24,
        position: "absolute",
        right: 24,
        top: 18,
    },
    smallGreenDescArrowOpen: {
        width: 24,
        height: 24,
        rotate: "180deg",
    },
}));

export default useStyles;
